import { register } from "@ebay/nice-modal-react";
import { UserEditModal } from "./pages/users-list-page/user-edit-modal";
export const ProfilePage = () => import(/* webpackChunkName: "profile-page" */ "./pages/profile-page");
export const UsersPage = () => import(/* webpackChunkName: "users-list-page" */ "./pages/users-list-page");
export const registerModals = () => {
    register('user-edit-modal', UserEditModal);
};
